import React, {
  useState,
  useEffect,
  useImperativeHandle,
  forwardRef
} from 'react';
import './Components.css';

const HeadIdTaskIdInput = forwardRef(
  ({ result, currentTaskId, disabled = false, PreInputtedText }, ref) => {
    const [selectedTaskId, setSelectedTaskId] = useState('');
    const [validOption, setValidOption] = useState(true);

    const validateInputValue = (inputValue) => {
      if (currentTaskId !== '' && inputValue === currentTaskId) {
        return { isValid: false, finalId: '', idType: '' };
      }

      const regexTaskId = /^\d{4}-\d{5,6}-\d{2}$/;
      const regexHeadId = /^HD-\d{7}$/;

      if (regexTaskId.test(inputValue)) {
        return { isValid: true, finalId: inputValue, idType: 'TaskId' };
      }

      if (regexHeadId.test(inputValue)) {
        return { isValid: true, finalId: inputValue, idType: 'HeadId' };
      }

      if (inputValue === '') {
        return { isValid: true, finalId: '', idType: '' };
      }

      return { isValid: false, finalId: '', idType: '' };
    };

    function validateOption(isValidInput) {
      if (!disabled && isValidInput) {
        return true;
      } else if (disabled && !isValidInput) {
        return true;
      } else if (!disabled && !isValidInput) {
        return false;
      } else {
        return true;
      }
    }

    useImperativeHandle(ref, () => ({
      clear() {
        setSelectedTaskId('');
        setValidOption(true);
        result({ valid: true, taskId: '', type: '', committed: false, rawValue: '' });
      }
    }));

    useEffect(() => {
      if (PreInputtedText) {
        const validation = validateInputValue(PreInputtedText);
        setSelectedTaskId(PreInputtedText);
        setValidOption(validateOption(validation.isValid));
        result({ valid: validation.isValid, taskId: validation.finalId, type: validation.idType, committed: true, rawValue: PreInputtedText });
      }
    }, [PreInputtedText]);

    const handleTaskIdInput = (e) => {
      const inputValue = e.target.value;
      const validation = validateInputValue(inputValue);

      setSelectedTaskId(inputValue);
      setValidOption(validateOption(validation.isValid));

      result({ valid: validation.isValid, taskId: validation.finalId, type: validation.idType, committed: false, rawValue: inputValue });
    };

    const handleSubmit = () => {
      const validation = validateInputValue(selectedTaskId);
      setValidOption(validateOption(validation.isValid));

      if (!validation.isValid || validation.finalId === '' || disabled) {
        return;
      }

      result({ valid: validation.isValid, taskId: validation.finalId, type: validation.idType, committed: true, rawValue: selectedTaskId });
    };

    const handleKeyDown = (e) => {
      if (e.key === 'Enter') {
        e.preventDefault();
        handleSubmit();
      }
    };

    return (
      <div style={{ display: 'flex', flexDirection: 'row', width: '100%', gap: '10px' }}>
        <input
          style={{ width: '100%', outline: validOption ? '0' : '2px solid red', flex: '1' }}
          id="taskIdInput"
          className="input"
          type="text"
          maxLength="14"
          value={selectedTaskId}
          onChange={handleTaskIdInput}
          onKeyDown={handleKeyDown}
          disabled={disabled}
        />
        <button
          type="button"
          className="button"
          style={{ width: '100px', flexShrink: '0' }}
          disabled={!validateInputValue(selectedTaskId).isValid || validateInputValue(selectedTaskId).finalId === '' || disabled}
          onClick={handleSubmit}
        >
          Submit
        </button>
      </div>
    );
  }
);

export default HeadIdTaskIdInput;
